import { Outlet } from "react-router-dom";
import useIdleLogout from "@/hooks/useIdleLogout";
import ToniniVisionCTA from "@/components/ToniniVisionCTA";
import NasaHubCTA from "@/components/NasaHubCTA";
import Sidebar from "@/components/Sidebar";
import MobileHeader from "@/components/MobileHeader";

export default function Layout() {
  useIdleLogout();
  return (
    <div className="min-h-screen flex bg-black text-white">
      <Sidebar />
      <main className="flex-1 min-w-0 flex flex-col">
        <MobileHeader />
        <div className="flex-1">
          <Outlet />
        </div>
        <div className="md:hidden">
          <ToniniVisionCTA />
          <NasaHubCTA />
        </div>
      </main>
    </div>
  );
}
